import { Module } from 'vuex'
import { IRootState } from '../types'
import { updateUserPassword } from '@/api/admin/userApi'
import { ISystemState } from '@/store/admin/system-store-types'

const systemModule: Module<ISystemState, IRootState> = {
  namespaced: true,
  state() {
    return {
      temp: ''
    }
  },
  getters: {},
  mutations: {},
  actions: {
    async updatePasswordAction({ dispatch }, payload: any) {
      const result = await updateUserPassword({ ...payload })
      if (result.data) {
        // 修改密码成功后退出登录，清理会话
        await dispatch('login/logoutAction', null, { root: true })
      }
    }
  }
}
export default systemModule
